<template>
  <div class="table-row">
    <tr v-if="label" class="tree-menu">
      <td class="subcateg-title" >
        <div :style="indent">
        <span >{{ label }}</span>
        </div>
      </td>
      <td>{{ count }}</td>
    </tr>
    <template v-for="(node, index) in nodes">
      <tree-menu 
        v-if="node"
        :nodes="node.children" 
        :label="node.label"
        :count="node.count"
        :key="node.id+index"
        :depth="depth + 1"
      >
      </tree-menu>
    </template>
  </div>
</template>
<script>
  export default { 
    props: [ 'label', 'nodes', 'count', 'depth' ],
    name: 'tree-menu',
    computed: {
      indent() {
        return `padding-left: ${this.depth * 12}px`
      }
    }
  }
</script>
<style>
.table-row {
  width: 100%;
  display: contents
}

</style>